"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toJPISODateString = toJPISODateString;
var zeropad_1 = require("./zeropad");
var serverTimezoneOffset = new Date().getTimezoneOffset();
var fixTimezoneOffset = (serverTimezoneOffset + 9 * 60) * 60 * 1000;
function toJPISODateString(date) {
    var tzDate = new Date(date.getTime() + fixTimezoneOffset);
    return "".concat(tzDate.getFullYear(), "-").concat((0, zeropad_1.zeropad)(tzDate.getMonth() + 1, 2), "-").concat((0, zeropad_1.zeropad)(tzDate.getDate(), 2));
}
